import styled from 'styled-components';

const DashboardContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  row-gap: 20px;
  overflow: hidden;
  z-index: ${(props) => (props.legalNoticePopup ? 999 : 1)};
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 16px;
  }

  .headerContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    gap: 10px;

    @media (max-width: 1250px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 16px;
      gap: 16px;
    }
  }

  .lastMarketOnlineNbRestaurantNumber {
    position: relative;
  }

  .last-market-online-nb-restaurant-label {
    position: absolute;
    top: 53px;
    font-size: 28px;
  }
`;

const GridColumsContainer = styled.div`
  display: grid;
  grid-template-columns: 2.8fr 1fr;
  grid-gap: 20px;
  min-height: 76vh;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    min-height: 100px;
    margin-right: 0;
    margin-left: 0;
  }

  @media (max-width: 1200px) {
    min-height: 100px;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
  }
`;

const LeftContainer = styled.div`
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const RightContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: 20px;
  position: relative;
  border-radius: 10px;

  & > div {
    background-color: ${(props) => props.theme.colors['white']};
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    width: 100%;
    min-width: initial;
    max-width: initial;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }

  @media (max-width: 845px) {
    grid-template-columns: 1fr;
  }
`;

export default DashboardContainer;
export { GridColumsContainer, LeftContainer, RightContainer };
